import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ContentService} from "../../../content/content.service";
import {NotificationSettings} from "../../../content/content.types";
import {Subscription} from "rxjs";

@Component({
  selector: 'as-schedule-notifications',
  templateUrl: 'schedule-notifications.component.html',
  styleUrls: ['./schedule-notifications.component.scss',
    '../../../common/elements/list/tag-list/tag-list.component.scss',

    '../../../common/styles/container.scss']
})
export class ScheduleNotificationsComponent implements OnInit {

  @Input() moduleSettings;
  @Input() title;
  @Input() type;
  @Input() isDisabled: boolean;
  @Input() hideUpdateButton: boolean = false;
  @Input() hideSettings: boolean = false;
  @Output() modelChange: EventEmitter<any> = new EventEmitter();
  @ViewChild('assignmentnotification', {static: true}) assignmentnotification;
  // @Input() customRecipients;

  expandSettings = {'notifications': false, 'student': false, 'manager': false, 'custom': false};
  error = {'email': null};
  expandCustomEmail = {email: 'same'};
  selectedIndex: number = null;
  customRecipient: string = null;
  customRecipients = [];
  notificationSettings: NotificationSettings;
  subscribers: Subscription[] = [];

  constructor(private ContentService: ContentService) {
  }

  ngOnInit() {

    this.notificationSettings = new NotificationSettings();
    this.notificationSettings.settings.student = this.moduleSettings.student;
    this.notificationSettings.settings.manager = this.moduleSettings.manager;
    this.notificationSettings.type = this.type;

    if (this.moduleSettings.other){
      this.customRecipients =  this.moduleSettings.other;
      this.expandSettings.custom = (this.customRecipients.length > 0)

    }
    // if (!this.notificationSettings){
    //   this.notificationSettings = new NotificationSettings();
    // }

    // this.subscribers.push(this.ContentService.fetchNotificationSettings(this.moduleSettings.settings.courseID, this.type).subscribe((result) => {
    //   if (result['settings']) {
    //     this.notificationSettings = result;
    //     this.moduleSettings.settings.notifyStudent = this.notificationSettings.settings.student.notify;
    //     this.moduleSettings.settings.notifyManager = this.notificationSettings.settings.manager.notify;
    //     this.customRecipients = this.notificationSettings.settings.other;
    //     this.expandSettings.custom = (this.customRecipients.length > 0);
    //
    //     // this.viewCustomEmail(this.notificationSettings.settings.other[0].email)
    //   }
    // }));
  }

  viewNotificationSettings(type: string) {
    this.expandSettings[type] = !this.expandSettings[type];
  }

  viewCustomEmail(email: any) {

    if (this.expandCustomEmail.email == email) {
      this.expandCustomEmail.email = null;
    } else {
      this.expandCustomEmail.email = email;
    }
    this.selectedIndex = this.customRecipients.findIndex((i) => i.email == email);
  }

  removeCustomRecipient(email: string) {
    let index = this.customRecipients.findIndex((i) => i.email == email);
    this.customRecipients.splice(index, 1);
  }

  addCustomRecipient() {
    this.error.email = null;
    if (this.ContentService.validateEmail(this.customRecipient)) {
      this.customRecipients.push({email: this.customRecipient, period: 0, periodType: "D", repeatDays: 0});
      this.viewCustomEmail(this.customRecipient);
      this.customRecipient = null;
    } else {
      this.error.email = "invalid email";
    }
  }

  populateNotifications(notificationSettings){
    if (notificationSettings){
      this.notificationSettings.settings = notificationSettings;
      this.customRecipients = notificationSettings.other;
      this.expandSettings.custom = notificationSettings.other.length > 0;

    }

  };

  public updateNotifications() {

    this.notificationSettings.settings = {
      manager: {
        "notify": this.notificationSettings.settings.manager.notify ? 1 : 0,
        "period": this.notificationSettings.settings.manager.period,
        "periodType": this.notificationSettings.settings.manager.periodType,
        "repeatDays": this.notificationSettings.settings.manager.repeatDays.toString(),
        "email": ""
      },
      student: {
        "notify": this.notificationSettings.settings.student.notify ? 1 : 0,
        "period": this.notificationSettings.settings.student.period,
        "periodType": this.notificationSettings.settings.student.periodType,
        "repeatDays": this.notificationSettings.settings.student.repeatDays.toString(),
        "email": ""
      },
      other: this.customRecipients,
    }
    this.notificationSettings.objectID = 0;
    this.notificationSettings.type = this.type;

  }

  ngOnDestroy() {
    this.subscribers.forEach((s) => s.unsubscribe());
  }
}
